import { useTranslation } from 'react-i18next';
import { MaintenanceTable } from '../Layouts/DataTable';
import { EApiType, EDataMaintenanceType, EModuleType } from '../../data/Constants';
import { getImages } from '../../store/states/ImagesSlice';
import { useApiError } from '../../hooks';

import type { IManagementProps } from '../../../types';

export const Images = (props: IManagementProps) => {
  const { t } = useTranslation();
  const errorElement = useApiError(EApiType.ImagesKey);

  if (errorElement) return errorElement;

  return (
    <>
      <h3 className="mainHeader"> {t('header.image')} </h3>
      <MaintenanceTable
        token={props.token}
        type={EDataMaintenanceType.Images}
        getDataList={getImages}
        moduleType={EModuleType.Datamaintainance}
      />
    </>
  );
};
